import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper';
import Table from '@/common/components/Table';
import TextField from '@/common/components/TextField';
import { useTmaisUsers } from '@/common/hooks/queries/useTmaisUsers';
import useDebounce from '@/common/hooks/useDebounce';
import { useFilterParams } from '@/common/hooks/useFilterParams';
import { Mapper } from '@/common/services/mapper';
import { tmaisUsersDefaultColumns } from '@/features/tmaisUsers/constants/tmaisUsersDefaultColumns.constant';
import { TmaisUsersTransformer } from '@/features/tmaisUsers/services/tmaisUsersTransformer';
import { TmaisUserData, TmaisUserTableItem } from '@/features/tmaisUsers/types/tmaisUsers.type';
import { SearchIcon } from 'lucide-react';

export default function TmaisUsersList() {
  const { filterParams, setFilterParams } = useFilterParams();

  const [search, setSearch] = useDebounce(filterParams.search || '');

  const {
    data: tmaisUsers,
    meta: metaTmaisUsers,
    isLoading: tmaisUsersIsLoading,
    error: tmaisUsersError = {} as any,
    refetch: refetchTmaisUsers
  } = useTmaisUsers<TmaisUserData[]>({
    filters: {  
      page: filterParams.page || 1,
      search,
    },
    mapper: Mapper.mapWithTransformer<TmaisUserData[], TmaisUserTableItem[]>({ transformer: TmaisUsersTransformer.tableTransformer() })
  })

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-192px)]"
      statusCode={tmaisUsersError?.status}
      refetchFunction={refetchTmaisUsers}
    >
      <div className="h-[calc(100vh-192px)] flex flex-col gap-6">
        <TextField
          name="search"
          LeftIcon={<SearchIcon />}
          placeholder="Pesquisar"
          className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
          value={filterParams.search}
          onChange={(e) => {
            setSearch((e.target as HTMLInputElement).value);
            setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }))
          }}
        />

        <Table
          columns={tmaisUsersDefaultColumns}
          isLoadingData={tmaisUsersIsLoading}
          page={filterParams.page || 1}
          rows={tmaisUsers || []}
          totalPages={metaTmaisUsers.total_pages}
          totalCount={metaTmaisUsers.total}
          hasPagination
          setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
        />
      </div>
    </ErrorMessageWrapper>
  )
}
